// extracted by mini-css-extract-plugin
export var formContainer = "_ir-0";
export var message = "_ir-1";